// extracted by mini-css-extract-plugin
export default {"mainTabCryptocurrency":"style_mainTabCryptocurrency__ucAaE","viewAssets":"style_viewAssets__b1sjx"};